import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ShopModule } from './components/shop/shop.module';
import { UIRouterModule } from '@uirouter/angular';
import { RoutingModule } from './components/routing/routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FavoritesModule } from './components/favorites/favorites.module';
//import { MailAlertModule } from './components/mail-alert/mail-alert.module';
import { CoreModule } from './components/core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Angulartics2UirouterModule } from 'angulartics2/uiroutermodule';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { environment } from '../environments/environment';
import { dynamicStateConfigFn, LocaleModule, LocaleService } from '@ngx-ivengi/locale';
import { AppConfigService } from './app.config.service';
import { AppHttpInterceptor } from './app.http-interceptor';
import { LayoutModule } from '@angular/cdk/layout';


const domainGroup = environment.domainGroups.find(_domainGroup => {
  return (typeof(_domainGroup.find(_domainSettings => (_domainSettings.domain === window.location.host))) !== 'undefined');
});

const domainSettings = domainGroup.find(_domainSettings => (_domainSettings.domain === window.location.host));

AppConfigService.setDomainSettings(domainSettings);

const languages = ['nl-NL', 'nl-BE', 'de-DE']
  .filter((navItem) => (domainSettings.language.visibleLanguages.indexOf(navItem) !== -1));

const browserCultureLang = LocaleService.getBrowserCultureLang();

const routes = require('../assets/i18n/routes.json');

LocaleService.setTranslations(routes);
LocaleService.setAvailableLanguageISO(languages);
LocaleService.setDefaultLanguageISO((languages.indexOf(browserCultureLang) !== -1) ? browserCultureLang : languages[0]);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initializeApp(appConfigService: AppConfigService) {
  return () => appConfigService.initializeApp();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    UIRouterModule.forRoot({
      otherwise: { state: 'shop'},
      config: dynamicStateConfigFn,
      states: [],
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    CoreModule,
    ShopModule,
    FavoritesModule,
    LocaleModule,
    //MailAlertModule,
    RoutingModule,
    Angulartics2UirouterModule.forRoot([Angulartics2GoogleTagManager], {
      pageTracking: {
        clearQueryParams: true
      },
      gtm: {
        userId: 'GTM-WDBQBCQ'
      }
    }),
    LayoutModule,
  ],
  providers   : [
    AppConfigService,
    // LocaleService,
    { provide: 'Window',  useValue: window },
    { provide: APP_INITIALIZER, useFactory: initializeApp, multi: true, deps: [AppConfigService] },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
  ],
  bootstrap   : [AppComponent]
})

export class AppModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/app.module.ts